
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/faq",
      function () {
        return require("private-next-pages/help/faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/faq"])
      });
    }
  